export enum FormFieldTypes {
  array = 'ARRAY',
  oneOf = 'ONEOF',
  boolean = 'BOOLEAN',
  date = 'DATE',
  dateRange = 'DATE_RANGE',
  string = 'STRING',
  select = 'SELECT',
  number = 'NUMBER',
  option = 'OPTION',
  object = 'OBJECT',
  sectionTitle = 'sectionTitle',
}
